import {
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell
} from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export const TableContainerStyled = styled(TableContainer)``

export const TableStyled = styled(Table)`
  font-size: 1rem;
`

export const TableHeadStyled = styled(TableHead)`
  th {
    background: ${COLORS.tableColor};
    color: ${COLORS.blueFonts};
    line-height: 0;
  }
`

export const TableBodyStyled = styled(TableBody)`
  td {
    padding: 4px 16px;
  }
`
type TableRowProps = {
  evenNumber?: boolean
}
export const TableRowStyled = styled(TableRow)<TableRowProps>`
  border: 0.1rem solid #fefefe;
  background: ${({ evenNumber }) => evenNumber && COLORS.white};
`

interface ITableCell {
  minwidth?: string
  maxwidth?: string
}
export const TableCellStyled = styled(TableCell)<ITableCell>`
  && {
    min-width: ${({ minwidth }) => minwidth};
    max-width: ${({ maxwidth }) => maxwidth};
  }
`
